import Donut from './icons/Donut';
import Wheelchair from './icons/Wheelchair';
import Star from './icons/Star';
import EmptySet from './icons/EmptySet';
import Square from './icons/Square';
import Circle from './icons/Circle';


export default {
  Donut,
  Wheelchair,
  Star,
  EmptySet,
  Square,
  Circle,
};
